import { createStyles, makeStyles } from '@material-ui/core/styles';
import { PRIMARY, SECONDARY } from 'constants/colors';
export default makeStyles(theme => createStyles({
  bilistaOverviewCard: {
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      marginTop: -theme.spacing(5),
      marginBottom: -theme.spacing(8)
    },
    '& svg': {
      transition: '.2s',
      transform: 'translateX(0px)',
      marginRight: '-20px',
      opacity: '0%'
    },
    '&:hover svg': {
      transition: '.2s',
      transform: 'translateX(10px)',
      marginRight: '-4px',
      opacity: '100%'
    }
  },
  bilistaOverviewCardLabel: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    [theme.breakpoints.up('sm')]: {
      height: 'min(9%, 45px)',
      bottom: '30%'
    },
    bottom: '7%',
    height: '45px',
    zIndex: 999,
    background: PRIMARY,
    color: SECONDARY,
    padding: '6px 20px',
    fontSize: '150%',
    borderRadius: '0 4px 4px 0',
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    margin: 0,
    fontWeight: 'bold'
  }
}));